import React from "react";

const GameBlock = (props) => {
  return (
    <div
      class={props.style.game_block}
      onClick={() => {
        if (!props.game.coming && props.onClick) props.onClick();
      }}
    >
      {!props.game.coming ? (
        <div class={props.style.game_block_header + (props.game.jackpot ? ` ${props.style.game_block_header_jackpot}` : "")}>
          {/*{props.game.jackpot ? (*/}
          {/*  <img src={require("@/assets/images/home/jp.png").default} />*/}
          {/*) : (*/}
          {/*  <img src="../../assets/images/home/onlines.gif" />*/}
          {/*)}*/}
          {/*{props.game.jackpot ? `${props.game.jackpot}` : props.game.online}*/}
        </div>
      ) : (
        <div class={props.style.game_block_empty_header} />
      )}
      <div class={props.style.game_block_img} style={{backgroundImage:`url(${props.game.img})`}}>
        {props.game.coming ? <img class={props.style.coming_cover} src={require("@/assets/images/games/coming.png").default} /> : null}
      </div>
    </div>
  );
};

export default GameBlock;
